// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"1809bd13","345":"3bdc6b06"}[chunkId] + ".chunk.css";
};